<div id="main" tabindex="-1">
     <router-outlet></router-outlet>
     <app-ms-clarity></app-ms-clarity>
     <app-hot-jar></app-hot-jar>
</div>
